/**
 * WhatsApp sending health - a number's Meta messaging limit and quality
 * rating, as stored from Meta's raw values (`TIER_1K`, `GREEN`, ...). Shared
 * so the API (campaign pacing) and the web (Channels / Campaigns pages)
 * read them the same way.
 */
/** The daily limit assumed while Meta's real one is unknown - a new business's limit. */
export const DEFAULT_MESSAGING_LIMIT = 250;
/**
 * Share of the daily limit campaigns may use - the rest is kept for
 * reminders, order updates and other business-started messages.
 */
export const CAMPAIGN_LIMIT_SHARE = 0.8;
/**
 * Customers a number may start conversations with per rolling 24h:
 * a number, `'UNLIMITED'`, or null when unknown (never checked, or a value
 * Meta added later).
 */
export function messagingLimitFromTier(tier) {
    if (!tier)
        return null;
    const t = tier.trim().toUpperCase();
    if (t === 'TIER_UNLIMITED' || t === 'UNLIMITED')
        return 'UNLIMITED';
    const m = /^(?:TIER_)?(\d+)(K?)$/.exec(t);
    if (!m)
        return null;
    return Number(m[1]) * (m[2] === 'K' ? 1000 : 1);
}
/** Meta's GREEN / YELLOW / RED (anything else unknown). */
export function qualityLevel(rating) {
    switch ((rating ?? '').toUpperCase()) {
        case 'GREEN':
            return 'HIGH';
        case 'YELLOW':
            return 'MEDIUM';
        case 'RED':
            return 'LOW';
        default:
            return 'UNKNOWN';
    }
}
//# sourceMappingURL=whatsapp-health.js.map